'use strict';

import 'waypoints/lib/noframework.waypoints.min.js';

const SELECTOR = '.js-waypoint-element';
const TRIGGER = '.js-waypoint-trigger';

(function() {
	const trigger = document.querySelector(TRIGGER);
	const element = document.querySelector(SELECTOR);

    if (element === null) {
        return false;
    }

	new Waypoint({ // eslint-disable-line no-undef
		element: trigger,
		handler: function() {
			element.classList.toggle('is-visible');
		}
	});
})();
